import React from 'react';

const GeneralFunctions = () => {
  return (
    <div>

    </div>
  );
};

export default GeneralFunctions;